import './style/bolmateExternalLink.scss';

import {Icon} from '@iconify/react';

import classNames from 'classnames';

import React, {MouseEventHandler, PropsWithChildren} from 'react';

interface Props {
    href: string;
    label?: string;
    showIcon?: boolean;
    className?: string;
    onClick?: MouseEventHandler;
}

export default function BolmateExternalLink(props: PropsWithChildren<Props>) {
    const {href, children, label, showIcon = true, className, onClick} = props;

    return (
        <a
            href={href}
            target='_blank'
            rel='noopener noreferrer'
            className={classNames('bolmate-external-link', className)}
            onClick={onClick}
        >
            {children ?? label}
            {showIcon && <Icon icon='mdi:open-in-new' className='bolmate-external-link-icon' />}
        </a>
    );
}
